import { render } from "./CardAppDark.vue?vue&type=template&id=02483cb7&scoped=true"
import script from "./CardAppDark.vue?vue&type=script&lang=js"
export * from "./CardAppDark.vue?vue&type=script&lang=js"

import "./CardAppDark.vue?vue&type=style&index=0&id=02483cb7&scoped=true&lang=css"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02483cb7"]])

export default __exports__